/**
 * @file index.tsx
 *
 * @fileoverview Renders link referring to the font styles file.
 */
import localFont from 'next/font/local';
const ubuntu = localFont({
  src: [
    {
      path: './../../../../../public/fonts/woff2/Ubuntu-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Ubuntu-Medium.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Ubuntu-Bold.woff2',
      weight: '900',
      style: 'regular',
    },
  ],
});

export const NextFontSlot = ({ children }) => (
  <div className={ubuntu.className}>
    {children}
    <style jsx global>{`
      :root {
        --font-family-body: ${ubuntu.style.fontFamily};
        --font-family-headings: ${ubuntu.style.fontFamily};
      }
    `}</style>
  </div>
);
